import React, { ReactElement, useState } from "react"
import { Modal } from "antd"

import DriverPayForm from "../DriverPayForm/DriverPayForm.container"
import { PriceConfiguration } from "@/types/drivesAppSettings"

interface IDriverPayFormModalProps {
  button: ReactElement
  config?: PriceConfiguration
  type?: "teams" | "clients"
}

const DriverPayFormModal: React.FC<IDriverPayFormModalProps> = ({
  button,
  config,
  type = "teams",
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = () => {
    setIsModalVisible(true)
  }

  return (
    <>
      {React.cloneElement(button, { onClick: showModal })}
      <Modal
        open={isModalVisible}
        centered={true}
        className="editProfileModal"
        footer={null}
        closable={true}
        onCancel={() => setIsModalVisible(false)}
        destroyOnClose={true}
        zIndex={3000}
      >
        <div className="mt-6">
          <DriverPayForm config={config} setIsModalVisible={setIsModalVisible} type={type} />
        </div>
      </Modal>
    </>
  )
}

export default DriverPayFormModal
